import { useCallback, useContext } from "react";

import { type BTSelectItem } from "types/apiResponse/apiResponse";

import { type IBTSelectProps } from "commonComponents/btWrappers/BTSelect/BTSelect";
import { BTSelectCustomItemContext } from "commonComponents/btWrappers/BTSelect/BTSelectCustomItemContext";
import { type GridViewItem } from "commonComponents/utilities/Grid/common/GridSettings/GridSettings.api.types";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

export function useGridViewSelectCustomItemRender<FormValues = unknown>(): IBTSelectProps<
    FormValues,
    GridViewItem
>["customItemRender"] {
    return useCallback((item: BTSelectItem<GridViewItem>) => {
        return <GridViewSelectCustomItem item={item} />;
    }, []);
}

interface IGridViewSelectCustomItem {
    item: BTSelectItem<GridViewItem>;
}

export const GridViewSelectCustomItem: React.FunctionComponent<IGridViewSelectCustomItem> = ({
    item,
}) => {
    const selectContext = useContext(BTSelectCustomItemContext);
    const isSelectValueRender = selectContext?.isSelectedValueRender ?? false;

    return (
        <div className="flex justify-content-between align-items-center">
            {item.title}
            {!isSelectValueRender && item.extraData?.isDefault && (
                <StatusTagDisplay
                    className="margin-left-xss"
                    statusText="Default"
                    statusType="info"
                />
            )}
        </div>
    );
};
